import { ceil } from "./ceil";
import { floor } from "./floor";
import { round } from "./round";
export var PrecisionMath = {
    ceil: ceil,
    floor: floor,
    round: round
};
//# sourceMappingURL=index.js.map